import React, { FC } from 'react'
import './TransactionPending.scss'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { Link } from 'react-router-dom';
import { routingService } from 'app_services/routingService';
import { GrInProgress } from "react-icons/gr";
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper';
import { ITransactionStatus } from 'app_types/transaction/transactionTypes';

interface ITransactionPendingProps {
  isLoading: boolean
  transaction?: ITransactionStatus
  handleGetDetails: () => JSX.Element
}

const TransactionPending: FC<ITransactionPendingProps> = ({
  isLoading,
  transaction,
  handleGetDetails
}) => {
  return (
    <div className='transaction-pending--big-container'>
      <LoadingWrapper minHeight='614px' loading={isLoading}>
        <div className='transaction-pending--container'>
          <div className='transaction-pending--title'>Transacción pendiente</div>
          <div className='transaction-pending--timer-icon-container'>
            <GrInProgress className='transaction-pending--timer-icon'/>
          </div>
          <div className='transaction-pending--subtitle'>Muchas gracias por confiar en nosotros.</div>
          <div className='transaction-pending--text'>Estamos procesando tu transacción. Este proceso puede tardar unos minutos.</div>
          <div className='transaction-pending--subtitle'>Información de tu pedido</div>
          <div className='transaction-pending--text-container'>
            {handleGetDetails()}
          </div>
          <Link style={{marginTop: 'auto'}} to={routingService.getSecurePath('?section=certifications')}>
            <ButtonComponent variant='secondary' textTransform='none' width='100%' marginTop='20px'>Volver al sitio</ButtonComponent>
          </Link>
        </div>
      </LoadingWrapper>
    </div>
  )
}

export default TransactionPending
